export const AUTHORIZATION_PAYLOAD = {Authorization: `Bearer ${localStorage.getItem('authToken')}`}
